import request from '@/libs/request'

// 列表
export function commentsList (data) {
  return request({
    url: `comments/lists`,
    method: 'get',
    params: data
  })
}

export function comments (id) {
  return request({
    url: `comments/getInfo/${id}`,
    method: 'get'
  })
}
export function delbag (id) {
  return request({
    url: `bookBag/list/${id}`,
    method: 'delete'
  })
}

// 启用禁用用户
export function changeStatus (id) {
  return request({
    url: `bookBag/changeStatus/${id}`,
    method: 'post'
  })
}
